var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.914062,
    width: 24.0175,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93476 7.73233H11.1596V13.1308H9.93476V7.73233ZM13.8687 7.692C13.1239 7.692 12.5956 7.74024 12.2184 7.80508V13.1308H13.4283V11.2006C13.5414 11.2164 13.6845 11.2251 13.845 11.2251C14.5654 11.2251 15.1822 11.0479 15.5989 10.6549C15.9191 10.3497 16.0955 9.90215 16.0955 9.37313C16.0955 8.84491 15.8622 8.39735 15.519 8.12454C15.1584 7.83592 14.6207 7.692 13.8687 7.692ZM13.8355 10.2864C13.66 10.2864 13.5311 10.2785 13.4275 10.254V8.66146C13.5153 8.63774 13.6837 8.61323 13.9328 8.61323C14.5409 8.61323 14.8856 8.90976 14.8856 9.40556C14.8856 9.95829 14.4847 10.2864 13.8355 10.2864ZM12.5767 4C8.94396 4 6 6.94396 6 10.5759C6 14.2078 12.5767 20 12.5767 20C12.5767 20 19.1533 14.2086 19.1533 10.5767C19.1533 6.94475 16.2094 4 12.5767 4ZM12.5933 14.5747C10.1815 14.5747 8.22675 12.6192 8.22675 10.2066C8.22675 7.7948 10.1823 5.84007 12.5933 5.84007C15.0058 5.84007 16.9598 7.79559 16.9598 10.2066C16.9598 12.6184 15.005 14.5747 12.5933 14.5747Z",
    fill: "#C4A96B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.72b997a8616c5423bb9a750be0eff7f5.svg";
export { ForwardRef as ReactComponent };